import { classNames } from '~/utils/classNames';

export type IconBadgeType = 'neutral' | 'warning' | 'error' | 'info' | 'success';

export interface IconBadgeProps {
  type?: IconBadgeType;
  icon?: string;
}

export const IconBadge = ({ type = 'neutral', icon }: IconBadgeProps) => {
  return (
    <div
      className={classNames('shrink-0 flex items-center justify-center size-12 rounded-full text-2xl leading-none', {
        'bg-bolt-ds-neutralContainer text-bolt-ds-neutral': type === 'neutral',
        'bg-bolt-ds-warningContainer text-bolt-ds-warning': type === 'warning',
        'bg-bolt-ds-dangerContainer text-bolt-ds-danger': type === 'error',
        'bg-bolt-ds-brandContainer text-bolt-ds-brand': type === 'info',
        'bg-bolt-ds-successContainer text-bolt-ds-success': type === 'success',
      })}
    >
      {icon ? (
        <span className={icon} />
      ) : (
        <span
          className={classNames({
            'i-heroicons:exclamation-triangle': type === 'warning',
            'i-heroicons:exclamation-circle': type === 'error',
            'i-heroicons:information-circle': type === 'info',
            'i-heroicons:check-circle': type === 'success',
            'i-heroicons:star': type === 'neutral',
          })}
        >
          {type}
        </span>
      )}
    </div>
  );
};
